/* Esse objeto reúne constantes para códigos de permissões de recursos e rotas. O objetivo é ter uma estrutura
semelhante ao desktop para manter a compatibilidade de permissões durante a migração desktop-web */

export const PERMS = {
  // módulo gerencial
  GERENCIAL_MENU_PRODUCAO: 40001,
  GERENCIAL_MENU_OPERACIONAL: 40002,
  GERENCIAL_MENU_FINANCEIRO: 40003,
  GERENCIAL_MENU_ADMINISTRATIVO: 40004,

  // módulo front
  FRONT_CADASTRO_CATEGORIA_SERVICO: 12002,
  FRONT_CADASTRO_SERVICO: 12003,
  FRONT_PROCEDIMENTOS_ORDEM_DE_SERVICO: 12018,
  FRONT_CADASTRO_VEICULO_TIPO_DE_VEICULO: 12045,
  FRONT_CADASTRO_VEICULO: 12046,
  OS_ALTERA_CLIENTE_DO_SERVICO: 12059, // altera cliente do serviço - permissão interna
  FRONT_CADASTRO_PACOTES: 12081,
  FRONT_CADASTRO_VENDEDORES: 12082,
  FRONT_CADASTRO_MENU_SUGESTIVO: 12124,
  FRONT_CADASTRO_MOTIVO_CANCELAMENTO_TROCA: 12138,
  FRONT_CADASTRO_TABELA_PACOTE: 12229,
  FRONT_CADASTRO_USUARIOS: 12016,

  // módulo frotas
  FROTAS_MENU_CADASTRO_TIPO_DE_VEICULO: 26001,
  FROTAS_MENU_CADASTRO_VEICULO: 26002,
  FROTAS_MENU_CADASTRO_MARCA_VEICULO: 26003,
  FROTAS_MENU_CADASTRO_MODELO_VEICULO: 26004,
  FROTAS_PROCEDIMENTOS_ORDENS_DE_SERVICO: 26021,
  FROTAS_PROCEDIMENTOS_ABASTECIMENTO_LANCAR: 26022,

  // módulo finanças
  FINANCAS_MENU_CADASTRO_HISTORICO_BANCARIO: 22001,
  FINANCAS_MENU_CADASTRO_TIPO_DOCUMENTO: 22002,
  FINANCAS_MENU_CADASTRO_CENTRO_RECEITA_DESPESA: 22003,
  FINANCAS_MENU_CADASTRO_ORCAMENTO_RECEITA_DESPESA: 22096
};